import React from 'react';
import { Pagination } from '@mui/material';
import { ArcPaginationProps } from './types';

const ArcPagination: React.FC<ArcPaginationProps> = (props) => {
  return <Pagination shape="rounded" {...props} />;
};

export default ArcPagination;